module.exports = __webpack_public_path__ + "img/coupon-2.e137961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity-coupon/coupon-2.png
// module id = NVVS
// module chunks = 1